import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, DatePicker, Button, InputNumber, message, Upload } from "antd";
import useCurrentUser from "../../../../../hooks/useCurrentUser";
import { ModalCadastroSingleChargeProps } from "../../types";
import { Modal as ConfirmModal } from "../modalConfirmation/modalConfirmation";
import dayjs from "dayjs";


export const ModalCadastroSingleCharge: React.FC<ModalCadastroSingleChargeProps> = ({
    open,
    onClose,
    onCreate,
    onUpdate,
    mode,
    initialData,
}) => {
    const [form] = Form.useForm();
    const user = useCurrentUser();
    const [loading, setLoading] = React.useState(false);
    const isEdit = mode === "edit";
    const isView = mode === "view";
    const isPaid = !!initialData?.paymentDate;
    


    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingData, setPendingData] = useState<any>(null);
    const lockedFieldStyle: React.CSSProperties = {
        backgroundColor: "#f5f5f5",
        color: "#00000040",
        cursor: "not-allowed",
    };

    useEffect(() => {
    if (!open) return;

    if (mode === "edit" && initialData) {
        const dateToUse = initialData.paymentDate || initialData.finishDate;

        form.setFieldsValue({
            MerchantId: initialData.merchantId,
            Value: initialData.totalValue,
            Reason: initialData.reason,
            FinishDate: dateToUse
                ? dayjs(dateToUse, "YYYY-MM-DD")
                : null,
        });
    }

    if (mode === "create") {
        form.resetFields();
    }

}, [open, mode, initialData]);



    const handleConfirmation = async (isConfirmed: boolean) => {
        setShowConfirmModal(false);

        if (!isConfirmed || !pendingData) return;

        try {
            setLoading(true);

            await onCreate?.(pendingData);

            message.success("Cobrança criada com sucesso!");
            form.resetFields();
            onClose();

        } catch (error) {
            console.error(error);
            message.error("Erro ao criar cobrança");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            const now = new Date().toISOString();

            if (mode === "create") {
                const payload = {
                    merchantId: values.MerchantId,
                    nickName: values.nickName,
                    value: Number(values.Value),
                    reason: values.Reason,
                    createdBy: user.email,
                    createdAt: now,
                    finishDate: values.FinishDate
                        ? values.FinishDate.format("YYYY-MM-DD")
                        : null,
                };

                setPendingData(payload);
                setShowConfirmModal(true);
            }

            if (mode === "edit" && onUpdate && initialData) {
                await onUpdate({
                    id: initialData.manualBillingId,
                    reason: values.Reason,
                    updatedAt: now,
                    updatedBy: user.email,
                });

                message.success("Cobrança atualizada com sucesso!");
                form.resetFields();
                onClose();
            }

        } catch (error) {
            console.error(error);
            message.error("Erro ao validar formulário");
        }
    };
    <InputNumber
        style={{ width: "100%" }}
        min={0}
        disabled={isEdit || isView}
        formatter={(value) =>
            `R$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    />

    return (
        <>
            <Modal
                title={mode === "create" ? "Cadastrar Cobrança Pontual" : isEdit ? "Editar Cobrança Pontual" : "Visualizar Cobrança"}
                open={open}
                onCancel={onClose}
                footer={null}
                centered
                width={720}
                destroyOnClose
            >
                <Form form={form} layout="vertical">

                    <Form.Item
                        label="Código Lojista:"
                        name="MerchantId"
                        rules={[
                            { required: true },
                            { pattern: /^[0-9]+$/, message: "Digite apenas números" }
                        ]}
                    >
                        <Input
                            disabled={isEdit}
                            inputMode="numeric"
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Valor:"
                        name="Value"
                        rules={[{ required: true }]}
                    >
                        <InputNumber<number>
                            style={{ width: "100%" }}
                            min={0}
                            disabled={isEdit}
                            precision={2}
                            formatter={(value) => {
                                if (!value) return "";
                                return `R$ ${value}`
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                            }}
                            parser={(value) => {
                                if (!value) return 0;

                                const parsed = value
                                    .replace(/[R$\s.]/g, "")
                                    .replace(",", ".");

                                return Number(parsed);
                            }}
                        />
                    </Form.Item>


                    <Form.Item
                        label="Data da Cobrança"
                        name="FinishDate"
                        rules={[{ required: !isEdit }]}
                    >
                        <DatePicker
                            disabled={isEdit}
                            style={{ width: "100%", ...(isEdit ? lockedFieldStyle : {}) }}
                            format="DD/MM/YYYY"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Justificativa:"
                        name="Reason"
                        rules={[{ required: true }]}
                    >
                        <Input.TextArea rows={3}
                         disabled={isPaid} />
                    </Form.Item>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                        <Button onClick={onClose}>Cancelar</Button>
                        <Button type="primary" onClick={handleSubmit} loading={loading}>
                            {isEdit ? "Atualizar" : "Cadastrar"}
                        </Button>
                    </div>

                </Form>
            </Modal>

            <ConfirmModal
                isShowing={showConfirmModal}
                onConfirmation={handleConfirmation}
            />
        </>
    );
};

